/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from './base-types';
import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@/apollo/codegen-compat';
import * as ApolloReactHooks from '@/apollo/codegen-compat';
const defaultOptions = {} as const;
export type BuilderPerformanceType =
  | 'ANSWERED'
  | 'ITERATIONS'
  | 'PUBLISHED';

export type BuilderStatus =
  | 'COMPLETED_LATE'
  | 'COMPLETED_ON_TIME'
  | 'INCOMPLETE'
  | 'UNSCHEDULED_COMPLETED';

export type HubActivityType =
  | 'ANNOUNCEMENT'
  | 'IDEA'
  | 'OFFER'
  | 'OTHER'
  | 'POST'
  | 'QUESTION'
  | 'REPLY';

export type AlertsQueryVariables = Exact<{
  page?: number | null | undefined;
  pageSize?: number | null | undefined;
}>;


export type AlertsQuery = { alerts: { totalAlertsCount: number | null, totalUnreadAlertsCount: number | null, alerts: Array<{ alertTypeId: number | null, alertTypeName: string | null, isSeen: boolean | null, seenAt: string | null, createdAt: string | null, alertIds: Array<number | null> | null, publishedFor: string | null, noteIds: Array<number | null> | null, hubActivityId: number | null, hubActivityReplyId: number | null, senderUsers: Array<{ userId: number | null, firstName: string | null, lastName: string | null, avatarUrl: string | null } | null> | null, project: { id: number | null, name: string | null } | null, builders: Array<{ id: number | null, title: string | null } | null> | null, topic: { topicId: number | null, title: string | null } | null, hub: { id: number | null, name: string | null, logo: string | null } | null, hubActivities: Array<{ id: number | null, typeId: number | null, ownerUserId: number | null } | null> | null, activityReplies: Array<{ id: number | null, typeId: number | null, parentReplyId: number | null, parentReplyTypeId: number | null } | null> | null, event: { id: number | null, name: string | null } | null, eventUpdates: Array<{ alertId: number | null, typeId: number | null, value: string | null } | null> | null, eventPosts: Array<{ id: number | null, parentPostId: number | null, isUserParentPostOwner: boolean | null } | null> | null, hubGroup: { id: number | null, name: string | null } | null } | null> | null } | null };

export type HubReportingActivitiesQueryVariables = Exact<{
  hubId: string | number;
  from?: string | null | undefined;
  to?: string | null | undefined;
}>;


export type HubReportingActivitiesQuery = { hubReporting: { activities: Array<{ hubActivityId: string | null, createdByUserId: string | null, hubActivityType: Types.HubActivityType | null, createdAt: string | null } | null> | null } | null };

export type HubReportingBuilderPerformanceQueryVariables = Exact<{
  hubId: string | number;
  hubGroupId?: string | number | null | undefined;
  language?: string | null | undefined;
}>;


export type HubReportingBuilderPerformanceQuery = { hubReporting: { builderPerformance: { builders: Array<{ id: string | null, title: string | null, projectId: string | null, status: Types.BuilderStatus | null } | null> | null, builderPerformances: Array<{ builderId: string | null, type: Types.BuilderPerformanceType | null, projectId: string | null, projectName: string | null, count: number | null } | null> | null } | null } | null };

export type HubActivityReportFieldsFragment = { hubActivityId: string | null, createdByUserId: string | null, hubActivityType: Types.HubActivityType | null, createdAt: string | null };

export type ReportingUserFieldsFragment = { userId: string | null, firstName: string | null, lastName: string | null, emailAddress: string | null, avatarUrl: string | null };

export type HubUserNotesReportFieldsFragment = { user: { userId: string | null, firstName: string | null, lastName: string | null, emailAddress: string | null, avatarUrl: string | null } | null, projectNotes: Array<{ id: string | null, userId: string | null, createdAt: string | null } | null> | null };

export type SchedulePerformanceProjectFieldsFragment = { id: string | null, name: string | null, builders: Array<{ projectId: string | null, id: string | null, status: Types.BuilderStatus | null, title: string | null } | null> | null };

export type HubBuilderPerformanceFieldsFragment = { builders: Array<{ id: string | null, title: string | null, projectId: string | null, status: Types.BuilderStatus | null } | null> | null, builderPerformances: Array<{ builderId: string | null, type: Types.BuilderPerformanceType | null, projectId: string | null, projectName: string | null, count: number | null } | null> | null };

export type HubReportingProjectNotesQueryVariables = Exact<{
  hubId: string | number;
  hubGroupId?: string | number | null | undefined;
  from?: string | null | undefined;
  to?: string | null | undefined;
}>;


export type HubReportingProjectNotesQuery = { hubReporting: { projectNotes: Array<{ user: { userId: string | null, firstName: string | null, lastName: string | null, emailAddress: string | null, avatarUrl: string | null } | null, projectNotes: Array<{ id: string | null, userId: string | null, createdAt: string | null } | null> | null } | null> | null } | null };

export type HubReportingSchedulePerformanceQueryVariables = Exact<{
  hubId: string | number;
  hubGroupId: string | number;
}>;


export type HubReportingSchedulePerformanceQuery = { hubReporting: { schedulePerformance: Array<{ id: string | null, name: string | null, builders: Array<{ projectId: string | null, id: string | null, status: Types.BuilderStatus | null, title: string | null } | null> | null } | null> | null } | null };

export type MarkAlertsReadMutationVariables = Exact<{ [key: string]: never; }>;


export type MarkAlertsReadMutation = { markAlertsRead: { count: number | null } | null };

export type RequestAccountDeletionMutationVariables = Exact<{ [key: string]: never; }>;


export type RequestAccountDeletionMutation = { requestAccountDeletion: { success: boolean | null, scheduledFor: string | null } | null };

export type UpdateHubBuilderTextMutationVariables = Exact<{
  hub_id: string | number;
  builder_id: string | number;
  lang: string;
  description?: string | null | undefined;
  intro?: unknown;
}>;


export type UpdateHubBuilderTextMutation = { updateHubBuilderText: { intro: unknown, description: string | null } | null };

export type UpdateHubSectionPartTextMutationVariables = Exact<{
  hub_id: string | number;
  section_part_id: string | number;
  lang: string;
  body?: unknown;
}>;


export type UpdateHubSectionPartTextMutation = { updateHubSectionPartText: { body: unknown } | null };

export type UpdateHubTopicTextMutationVariables = Exact<{
  hub_id: string | number;
  topic_id: string | number;
  lang: string;
  question?: string | null | undefined;
  intro?: unknown;
}>;


export type UpdateHubTopicTextMutation = { updateHubTopicText: { question: string | null, intro: unknown } | null };

export const HubActivityReportFieldsFragmentDoc = gql`
    fragment HubActivityReportFields on HubActivityReport {
  hubActivityId
  createdByUserId
  hubActivityType
  createdAt
}
    `;
export const ReportingUserFieldsFragmentDoc = gql`
    fragment ReportingUserFields on ReportingUser {
  userId
  firstName
  lastName
  emailAddress
  avatarUrl
}
    `;
export const HubUserNotesReportFieldsFragmentDoc = gql`
    fragment HubUserNotesReportFields on HubUserNotesReport {
  user {
    ...ReportingUserFields
  }
  projectNotes {
    id
    userId
    createdAt
  }
}
    ${ReportingUserFieldsFragmentDoc}`;
export const SchedulePerformanceProjectFieldsFragmentDoc = gql`
    fragment SchedulePerformanceProjectFields on SchedulePerformanceProject {
  id
  name
  builders {
    projectId
    id
    status
    title
  }
}
    `;
export const HubBuilderPerformanceFieldsFragmentDoc = gql`
    fragment HubBuilderPerformanceFields on HubBuilderPerformance {
  builders {
    id
    title
    projectId
    status
  }
  builderPerformances {
    builderId
    type
    projectId
    projectName
    count
  }
}
    `;
export const AlertsDocument = gql`
    query Alerts($page: Int, $pageSize: Int) {
  alerts(page: $page, pageSize: $pageSize) {
    totalAlertsCount
    totalUnreadAlertsCount
    alerts {
      alertTypeId
      alertTypeName
      isSeen
      seenAt
      createdAt
      alertIds
      senderUsers {
        userId
        firstName
        lastName
        avatarUrl
      }
      project {
        id
        name
      }
      builders {
        id
        title
      }
      publishedFor
      topic {
        topicId
        title
      }
      noteIds
      hub {
        id
        name
        logo
      }
      hubActivities {
        id
        typeId
        ownerUserId
      }
      hubActivityId
      hubActivityReplyId
      activityReplies {
        id
        typeId
        parentReplyId
        parentReplyTypeId
      }
      event {
        id
        name
      }
      eventUpdates {
        alertId
        typeId
        value
      }
      eventPosts {
        id
        parentPostId
        isUserParentPostOwner
      }
      hubGroup {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useAlertsQuery__
 *
 * To run a query within a React component, call `useAlertsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAlertsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAlertsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useAlertsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AlertsQuery, AlertsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AlertsQuery, AlertsQueryVariables>(AlertsDocument, options);
      }
export function useAlertsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AlertsQuery, AlertsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AlertsQuery, AlertsQueryVariables>(AlertsDocument, options);
        }
// @ts-ignore
export function useAlertsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AlertsQuery, AlertsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AlertsQuery, AlertsQueryVariables>;
export function useAlertsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AlertsQuery, AlertsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AlertsQuery | undefined, AlertsQueryVariables>;
export function useAlertsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AlertsQuery, AlertsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AlertsQuery, AlertsQueryVariables>(AlertsDocument, options);
        }
export type AlertsQueryHookResult = ReturnType<typeof useAlertsQuery>;
export type AlertsLazyQueryHookResult = ReturnType<typeof useAlertsLazyQuery>;
export type AlertsSuspenseQueryHookResult = ReturnType<typeof useAlertsSuspenseQuery>;
export type AlertsQueryResult = ApolloReactCommon.QueryResult<AlertsQuery, AlertsQueryVariables>;
export const HubReportingActivitiesDocument = gql`
    query HubReportingActivities($hubId: ID!, $from: Date, $to: Date) {
  hubReporting(hubId: $hubId, from: $from, to: $to) {
    activities {
      ...HubActivityReportFields
    }
  }
}
    ${HubActivityReportFieldsFragmentDoc}`;

/**
 * __useHubReportingActivitiesQuery__
 *
 * To run a query within a React component, call `useHubReportingActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useHubReportingActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHubReportingActivitiesQuery({
 *   variables: {
 *      hubId: // value for 'hubId'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useHubReportingActivitiesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<HubReportingActivitiesQuery, HubReportingActivitiesQueryVariables> & ({ variables: HubReportingActivitiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<HubReportingActivitiesQuery, HubReportingActivitiesQueryVariables>(HubReportingActivitiesDocument, options);
      }
export function useHubReportingActivitiesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<HubReportingActivitiesQuery, HubReportingActivitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<HubReportingActivitiesQuery, HubReportingActivitiesQueryVariables>(HubReportingActivitiesDocument, options);
        }
// @ts-ignore
export function useHubReportingActivitiesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<HubReportingActivitiesQuery, HubReportingActivitiesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<HubReportingActivitiesQuery, HubReportingActivitiesQueryVariables>;
export function useHubReportingActivitiesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<HubReportingActivitiesQuery, HubReportingActivitiesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<HubReportingActivitiesQuery | undefined, HubReportingActivitiesQueryVariables>;
export function useHubReportingActivitiesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<HubReportingActivitiesQuery, HubReportingActivitiesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<HubReportingActivitiesQuery, HubReportingActivitiesQueryVariables>(HubReportingActivitiesDocument, options);
        }
export type HubReportingActivitiesQueryHookResult = ReturnType<typeof useHubReportingActivitiesQuery>;
export type HubReportingActivitiesLazyQueryHookResult = ReturnType<typeof useHubReportingActivitiesLazyQuery>;
export type HubReportingActivitiesSuspenseQueryHookResult = ReturnType<typeof useHubReportingActivitiesSuspenseQuery>;
export type HubReportingActivitiesQueryResult = ApolloReactCommon.QueryResult<HubReportingActivitiesQuery, HubReportingActivitiesQueryVariables>;
export const HubReportingBuilderPerformanceDocument = gql`
    query HubReportingBuilderPerformance($hubId: ID!, $hubGroupId: ID, $language: String) {
  hubReporting(hubId: $hubId) {
    builderPerformance(hubGroupId: $hubGroupId, language: $language) {
      ...HubBuilderPerformanceFields
    }
  }
}
    ${HubBuilderPerformanceFieldsFragmentDoc}`;

/**
 * __useHubReportingBuilderPerformanceQuery__
 *
 * To run a query within a React component, call `useHubReportingBuilderPerformanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useHubReportingBuilderPerformanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHubReportingBuilderPerformanceQuery({
 *   variables: {
 *      hubId: // value for 'hubId'
 *      hubGroupId: // value for 'hubGroupId'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useHubReportingBuilderPerformanceQuery(baseOptions: ApolloReactHooks.QueryHookOptions<HubReportingBuilderPerformanceQuery, HubReportingBuilderPerformanceQueryVariables> & ({ variables: HubReportingBuilderPerformanceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<HubReportingBuilderPerformanceQuery, HubReportingBuilderPerformanceQueryVariables>(HubReportingBuilderPerformanceDocument, options);
      }
export function useHubReportingBuilderPerformanceLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<HubReportingBuilderPerformanceQuery, HubReportingBuilderPerformanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<HubReportingBuilderPerformanceQuery, HubReportingBuilderPerformanceQueryVariables>(HubReportingBuilderPerformanceDocument, options);
        }
// @ts-ignore
export function useHubReportingBuilderPerformanceSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<HubReportingBuilderPerformanceQuery, HubReportingBuilderPerformanceQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<HubReportingBuilderPerformanceQuery, HubReportingBuilderPerformanceQueryVariables>;
export function useHubReportingBuilderPerformanceSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<HubReportingBuilderPerformanceQuery, HubReportingBuilderPerformanceQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<HubReportingBuilderPerformanceQuery | undefined, HubReportingBuilderPerformanceQueryVariables>;
export function useHubReportingBuilderPerformanceSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<HubReportingBuilderPerformanceQuery, HubReportingBuilderPerformanceQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<HubReportingBuilderPerformanceQuery, HubReportingBuilderPerformanceQueryVariables>(HubReportingBuilderPerformanceDocument, options);
        }
export type HubReportingBuilderPerformanceQueryHookResult = ReturnType<typeof useHubReportingBuilderPerformanceQuery>;
export type HubReportingBuilderPerformanceLazyQueryHookResult = ReturnType<typeof useHubReportingBuilderPerformanceLazyQuery>;
export type HubReportingBuilderPerformanceSuspenseQueryHookResult = ReturnType<typeof useHubReportingBuilderPerformanceSuspenseQuery>;
export type HubReportingBuilderPerformanceQueryResult = ApolloReactCommon.QueryResult<HubReportingBuilderPerformanceQuery, HubReportingBuilderPerformanceQueryVariables>;
export const HubReportingProjectNotesDocument = gql`
    query HubReportingProjectNotes($hubId: ID!, $hubGroupId: ID, $from: Date, $to: Date) {
  hubReporting(hubId: $hubId, from: $from, to: $to) {
    projectNotes(hubGroupId: $hubGroupId) {
      ...HubUserNotesReportFields
    }
  }
}
    ${HubUserNotesReportFieldsFragmentDoc}`;

/**
 * __useHubReportingProjectNotesQuery__
 *
 * To run a query within a React component, call `useHubReportingProjectNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useHubReportingProjectNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHubReportingProjectNotesQuery({
 *   variables: {
 *      hubId: // value for 'hubId'
 *      hubGroupId: // value for 'hubGroupId'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useHubReportingProjectNotesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<HubReportingProjectNotesQuery, HubReportingProjectNotesQueryVariables> & ({ variables: HubReportingProjectNotesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<HubReportingProjectNotesQuery, HubReportingProjectNotesQueryVariables>(HubReportingProjectNotesDocument, options);
      }
export function useHubReportingProjectNotesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<HubReportingProjectNotesQuery, HubReportingProjectNotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<HubReportingProjectNotesQuery, HubReportingProjectNotesQueryVariables>(HubReportingProjectNotesDocument, options);
        }
// @ts-ignore
export function useHubReportingProjectNotesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<HubReportingProjectNotesQuery, HubReportingProjectNotesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<HubReportingProjectNotesQuery, HubReportingProjectNotesQueryVariables>;
export function useHubReportingProjectNotesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<HubReportingProjectNotesQuery, HubReportingProjectNotesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<HubReportingProjectNotesQuery | undefined, HubReportingProjectNotesQueryVariables>;
export function useHubReportingProjectNotesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<HubReportingProjectNotesQuery, HubReportingProjectNotesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<HubReportingProjectNotesQuery, HubReportingProjectNotesQueryVariables>(HubReportingProjectNotesDocument, options);
        }
export type HubReportingProjectNotesQueryHookResult = ReturnType<typeof useHubReportingProjectNotesQuery>;
export type HubReportingProjectNotesLazyQueryHookResult = ReturnType<typeof useHubReportingProjectNotesLazyQuery>;
export type HubReportingProjectNotesSuspenseQueryHookResult = ReturnType<typeof useHubReportingProjectNotesSuspenseQuery>;
export type HubReportingProjectNotesQueryResult = ApolloReactCommon.QueryResult<HubReportingProjectNotesQuery, HubReportingProjectNotesQueryVariables>;
export const HubReportingSchedulePerformanceDocument = gql`
    query HubReportingSchedulePerformance($hubId: ID!, $hubGroupId: ID!) {
  hubReporting(hubId: $hubId) {
    schedulePerformance(hubGroupId: $hubGroupId) {
      ...SchedulePerformanceProjectFields
    }
  }
}
    ${SchedulePerformanceProjectFieldsFragmentDoc}`;

/**
 * __useHubReportingSchedulePerformanceQuery__
 *
 * To run a query within a React component, call `useHubReportingSchedulePerformanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useHubReportingSchedulePerformanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHubReportingSchedulePerformanceQuery({
 *   variables: {
 *      hubId: // value for 'hubId'
 *      hubGroupId: // value for 'hubGroupId'
 *   },
 * });
 */
export function useHubReportingSchedulePerformanceQuery(baseOptions: ApolloReactHooks.QueryHookOptions<HubReportingSchedulePerformanceQuery, HubReportingSchedulePerformanceQueryVariables> & ({ variables: HubReportingSchedulePerformanceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<HubReportingSchedulePerformanceQuery, HubReportingSchedulePerformanceQueryVariables>(HubReportingSchedulePerformanceDocument, options);
      }
export function useHubReportingSchedulePerformanceLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<HubReportingSchedulePerformanceQuery, HubReportingSchedulePerformanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<HubReportingSchedulePerformanceQuery, HubReportingSchedulePerformanceQueryVariables>(HubReportingSchedulePerformanceDocument, options);
        }
// @ts-ignore
export function useHubReportingSchedulePerformanceSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<HubReportingSchedulePerformanceQuery, HubReportingSchedulePerformanceQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<HubReportingSchedulePerformanceQuery, HubReportingSchedulePerformanceQueryVariables>;
export function useHubReportingSchedulePerformanceSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<HubReportingSchedulePerformanceQuery, HubReportingSchedulePerformanceQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<HubReportingSchedulePerformanceQuery | undefined, HubReportingSchedulePerformanceQueryVariables>;
export function useHubReportingSchedulePerformanceSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<HubReportingSchedulePerformanceQuery, HubReportingSchedulePerformanceQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<HubReportingSchedulePerformanceQuery, HubReportingSchedulePerformanceQueryVariables>(HubReportingSchedulePerformanceDocument, options);
        }
export type HubReportingSchedulePerformanceQueryHookResult = ReturnType<typeof useHubReportingSchedulePerformanceQuery>;
export type HubReportingSchedulePerformanceLazyQueryHookResult = ReturnType<typeof useHubReportingSchedulePerformanceLazyQuery>;
export type HubReportingSchedulePerformanceSuspenseQueryHookResult = ReturnType<typeof useHubReportingSchedulePerformanceSuspenseQuery>;
export type HubReportingSchedulePerformanceQueryResult = ApolloReactCommon.QueryResult<HubReportingSchedulePerformanceQuery, HubReportingSchedulePerformanceQueryVariables>;
export const MarkAlertsReadDocument = gql`
    mutation MarkAlertsRead {
  markAlertsRead {
    count
  }
}
    `;
export type MarkAlertsReadMutationFn = ApolloReactCommon.MutationFunction<MarkAlertsReadMutation, MarkAlertsReadMutationVariables>;

/**
 * __useMarkAlertsReadMutation__
 *
 * To run a mutation, you first call `useMarkAlertsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkAlertsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markAlertsReadMutation, { data, loading, error }] = useMarkAlertsReadMutation({
 *   variables: {
 *   },
 * });
 */
export function useMarkAlertsReadMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MarkAlertsReadMutation, MarkAlertsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<MarkAlertsReadMutation, MarkAlertsReadMutationVariables>(MarkAlertsReadDocument, options);
      }
export type MarkAlertsReadMutationHookResult = ReturnType<typeof useMarkAlertsReadMutation>;
export type MarkAlertsReadMutationResult = ApolloReactCommon.MutationResult<MarkAlertsReadMutation>;
export type MarkAlertsReadMutationOptions = ApolloReactCommon.BaseMutationOptions<MarkAlertsReadMutation, MarkAlertsReadMutationVariables>;
export const RequestAccountDeletionDocument = gql`
    mutation RequestAccountDeletion {
  requestAccountDeletion {
    success
    scheduledFor
  }
}
    `;
export type RequestAccountDeletionMutationFn = ApolloReactCommon.MutationFunction<RequestAccountDeletionMutation, RequestAccountDeletionMutationVariables>;

/**
 * __useRequestAccountDeletionMutation__
 *
 * To run a mutation, you first call `useRequestAccountDeletionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestAccountDeletionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestAccountDeletionMutation, { data, loading, error }] = useRequestAccountDeletionMutation({
 *   variables: {
 *   },
 * });
 */
export function useRequestAccountDeletionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RequestAccountDeletionMutation, RequestAccountDeletionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RequestAccountDeletionMutation, RequestAccountDeletionMutationVariables>(RequestAccountDeletionDocument, options);
      }
export type RequestAccountDeletionMutationHookResult = ReturnType<typeof useRequestAccountDeletionMutation>;
export type RequestAccountDeletionMutationResult = ApolloReactCommon.MutationResult<RequestAccountDeletionMutation>;
export type RequestAccountDeletionMutationOptions = ApolloReactCommon.BaseMutationOptions<RequestAccountDeletionMutation, RequestAccountDeletionMutationVariables>;
export const UpdateHubBuilderTextDocument = gql`
    mutation UpdateHubBuilderText($hub_id: ID!, $builder_id: ID!, $lang: String!, $description: String, $intro: JSON) {
  updateHubBuilderText(
    hubId: $hub_id
    builderId: $builder_id
    lang: $lang
    description: $description
    intro: $intro
  ) {
    intro
    description
  }
}
    `;
export type UpdateHubBuilderTextMutationFn = ApolloReactCommon.MutationFunction<UpdateHubBuilderTextMutation, UpdateHubBuilderTextMutationVariables>;

/**
 * __useUpdateHubBuilderTextMutation__
 *
 * To run a mutation, you first call `useUpdateHubBuilderTextMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHubBuilderTextMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateHubBuilderTextMutation, { data, loading, error }] = useUpdateHubBuilderTextMutation({
 *   variables: {
 *      hub_id: // value for 'hub_id'
 *      builder_id: // value for 'builder_id'
 *      lang: // value for 'lang'
 *      description: // value for 'description'
 *      intro: // value for 'intro'
 *   },
 * });
 */
export function useUpdateHubBuilderTextMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateHubBuilderTextMutation, UpdateHubBuilderTextMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateHubBuilderTextMutation, UpdateHubBuilderTextMutationVariables>(UpdateHubBuilderTextDocument, options);
      }
export type UpdateHubBuilderTextMutationHookResult = ReturnType<typeof useUpdateHubBuilderTextMutation>;
export type UpdateHubBuilderTextMutationResult = ApolloReactCommon.MutationResult<UpdateHubBuilderTextMutation>;
export type UpdateHubBuilderTextMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateHubBuilderTextMutation, UpdateHubBuilderTextMutationVariables>;
export const UpdateHubSectionPartTextDocument = gql`
    mutation UpdateHubSectionPartText($hub_id: ID!, $section_part_id: ID!, $lang: String!, $body: JSON) {
  updateHubSectionPartText(
    hubId: $hub_id
    sectionPartId: $section_part_id
    lang: $lang
    body: $body
  ) {
    body
  }
}
    `;
export type UpdateHubSectionPartTextMutationFn = ApolloReactCommon.MutationFunction<UpdateHubSectionPartTextMutation, UpdateHubSectionPartTextMutationVariables>;

/**
 * __useUpdateHubSectionPartTextMutation__
 *
 * To run a mutation, you first call `useUpdateHubSectionPartTextMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHubSectionPartTextMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateHubSectionPartTextMutation, { data, loading, error }] = useUpdateHubSectionPartTextMutation({
 *   variables: {
 *      hub_id: // value for 'hub_id'
 *      section_part_id: // value for 'section_part_id'
 *      lang: // value for 'lang'
 *      body: // value for 'body'
 *   },
 * });
 */
export function useUpdateHubSectionPartTextMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateHubSectionPartTextMutation, UpdateHubSectionPartTextMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateHubSectionPartTextMutation, UpdateHubSectionPartTextMutationVariables>(UpdateHubSectionPartTextDocument, options);
      }
export type UpdateHubSectionPartTextMutationHookResult = ReturnType<typeof useUpdateHubSectionPartTextMutation>;
export type UpdateHubSectionPartTextMutationResult = ApolloReactCommon.MutationResult<UpdateHubSectionPartTextMutation>;
export type UpdateHubSectionPartTextMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateHubSectionPartTextMutation, UpdateHubSectionPartTextMutationVariables>;
export const UpdateHubTopicTextDocument = gql`
    mutation UpdateHubTopicText($hub_id: ID!, $topic_id: ID!, $lang: String!, $question: String, $intro: JSON) {
  updateHubTopicText(
    hubId: $hub_id
    topicId: $topic_id
    lang: $lang
    question: $question
    intro: $intro
  ) {
    question
    intro
  }
}
    `;
export type UpdateHubTopicTextMutationFn = ApolloReactCommon.MutationFunction<UpdateHubTopicTextMutation, UpdateHubTopicTextMutationVariables>;

/**
 * __useUpdateHubTopicTextMutation__
 *
 * To run a mutation, you first call `useUpdateHubTopicTextMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHubTopicTextMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateHubTopicTextMutation, { data, loading, error }] = useUpdateHubTopicTextMutation({
 *   variables: {
 *      hub_id: // value for 'hub_id'
 *      topic_id: // value for 'topic_id'
 *      lang: // value for 'lang'
 *      question: // value for 'question'
 *      intro: // value for 'intro'
 *   },
 * });
 */
export function useUpdateHubTopicTextMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateHubTopicTextMutation, UpdateHubTopicTextMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateHubTopicTextMutation, UpdateHubTopicTextMutationVariables>(UpdateHubTopicTextDocument, options);
      }
export type UpdateHubTopicTextMutationHookResult = ReturnType<typeof useUpdateHubTopicTextMutation>;
export type UpdateHubTopicTextMutationResult = ApolloReactCommon.MutationResult<UpdateHubTopicTextMutation>;
export type UpdateHubTopicTextMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateHubTopicTextMutation, UpdateHubTopicTextMutationVariables>;